"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatter = void 0;
class NumberFormatter {
    static decimalSeparator(number, locale) {
        return number.toLocaleString(locale);
    }
    static stringValueDecimalSeparator(number, locale) {
        if (!number.includes('.')) {
            const parsedNumber = parseInt(number.replace(',', ''));
            if (!isNaN(parsedNumber)) {
                return parsedNumber.toLocaleString(locale);
            }
            return null;
        }
        const parsedNumber = parseFloat(number.replace(',', '.'));
        if (!isNaN(parsedNumber)) {
            return parsedNumber.toLocaleString(locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
        return null;
    }
    static groupSep(number, locale) {
        let sep = number.toLocaleString(locale).charAt(1);
        if (sep === '0')
            return '';
        return sep;
    }
}
exports.NumberFormatter = NumberFormatter;
//# sourceMappingURL=numberFormatter.js.map